import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForkKnife: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconForkKnife"><Path d="M10 3H11.5V11.2727L9.5 13.5V21H6V13.5L4 11.2727V3H5.5V10.75H7V3H8.5V10.75H10V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 3H19.2546C18.9603 3 18.6697 3.12954 18.4553 3.2468C18.2102 3.3808 17.9377 3.57081 17.6518 3.81201C17.0782 4.29592 16.4152 5.01564 15.7735 5.9928C14.4865 7.95267 13.2785 10.9572 13.0437 15.2084L13 16H16.5213V21H20V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconForkKnife;
